"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.gaEvents = void 0;
const utils_1 = require("./utils");
const utils_common_is_webview_1 = __importDefault(require("@gcloud-npm/utils.common.is-webview"));
const utils_metrics_send_ga_page_event_1 = __importDefault(require("@gcloud-npm/utils.metrics.send-ga-page-event"));
const utils_secure_local_storage_1 = __importDefault(require("@gcloud-npm/utils.secure.local-storage"));
const normalizeZipCode = (zipcode) => {
    let res = "";
    if (zipcode === "ZR")
        res = "regulada";
    if (zipcode === "ZL")
        res = "libre";
    if (zipcode === "ZM")
        res = "mixta";
    return res;
};
const isUserLoggedIn = (context) => {
    let res = false;
    if (context) {
        res =
            context.userIdPartyHash ||
                context.userCUCFijoHash ||
                context.userCUCMovilHash ||
                context.userCUCPrepagoHash;
    }
    return res;
};
/**
 * Envio a GA sobre info el usuario según valor de cookies
 * @returns {boolean} - true si han transcurrido seis meses, false si no.
 */
const sendGaConfig = ({ context, shouldSendHash, setContextData }) => __awaiter(void 0, void 0, void 0, function* () {
    var _a;
    const data = (0, utils_1.createPageEventObject)(context);
    const secureCookieStorageLib = new utils_secure_local_storage_1.default();
    const persistedInfo = secureCookieStorageLib.getItem("ts");
    const { userIdPartyHashFromGetEg, userPo } = persistedInfo;
    const mainProperties = (0, utils_1.extractMainProperties)(data);
    const userProperties = (0, utils_1.extractUserProperties)(data, shouldSendHash, userIdPartyHashFromGetEg);
    const zipcode = normalizeZipCode(((_a = persistedInfo === null || persistedInfo === void 0 ? void 0 : persistedInfo.geo) === null || _a === void 0 ? void 0 : _a.zone) || "");
    const logado = isUserLoggedIn(context);
    const normalizeEg = (0, utils_1.normalizeUserEg)(persistedInfo);
    const finalUserPo = userPo ? JSON.stringify(userPo) : "";
    /* ------------------------ extraemos info del secure ----------------------- */
    let x = "";
    let mobile = null;
    if (persistedInfo && persistedInfo.geo && persistedInfo.geo.x) {
        ({ x } = persistedInfo.geo);
    }
    if (persistedInfo && persistedInfo.geo && persistedInfo.geo.mobile !== 'undefined') {
        ({ mobile } = persistedInfo.geo);
    }
    try {
        gtag("config", `${process.env.NEXT_PUBLIC_GTM_ID}`, Object.assign(Object.assign(Object.assign(Object.assign({ page_variation: logado ? "cliente" : "no-cliente", transport_url: "https://metrics.col.movistar.es", first_party_collection: true }, mainProperties), userProperties), { 'user_x': x, 'user_mobile_network': mobile, "zip-code": zipcode, user_po: finalUserPo }), normalizeEg));
        /* ------------------- mandamos pageview para los webview ------------------- */
        if ((0, utils_common_is_webview_1.default)()) {
            let retries = 10;
            let waitWB = setInterval(() => __awaiter(void 0, void 0, void 0, function* () {
                retries--;
                if (window.webviewBridge && window.webviewBridge.setScreenName) {
                    retries = -1;
                    const currentPageName = mainProperties && mainProperties['page_name'];
                    window.webviewBridge.setScreenName(currentPageName);
                }
                if (retries < 0) {
                    clearInterval(waitWB);
                }
            }), 100);
        }
        /* ------ intentamos bindear al contexto de redux la session id de ga4 ------ */
        gtag("get", "G-J1GJWFY08P", "session_id", (sessionId) => {
            if (context && context.clientIDs) {
                context.clientIDs.sessionId = sessionId;
                setContextData(context);
            }
        });
    }
    catch (e) {
        console.log(e);
    }
    // Envia a GA el evento page_printed una vez ya tiene toda la info
    (0, utils_metrics_send_ga_page_event_1.default)();
});
/**
 * Actualiza si el cliente ha aceptado las cookies.
 * @returns {boolean} - true si han transcurrido seis meses, false si no.
 */
const gaEvents = ({ context, setContextData, ad_storage, analytics_storage, ad_user_data, ad_personalization, }) => __awaiter(void 0, void 0, void 0, function* () {
    const shouldSendHash = ad_storage === "granted" && analytics_storage === "granted";
    if (ad_storage !== "denied" || analytics_storage !== "denied") {
        try {
            gtag("consent", "update", {
                ad_storage,
                analytics_storage,
                ad_user_data,
                ad_personalization,
            });
        }
        catch (e) {
            console.log(e);
        }
    }
    sendGaConfig({ context, shouldSendHash, setContextData });
});
exports.gaEvents = gaEvents;
exports.default = exports.gaEvents;
//# sourceMappingURL=index.js.map